<template>
  <div class="space-y-5">
    <div class="bg-white px-8 py-4">
      <Classify></Classify>
    </div>

    <div class="grid grid-rows-[2rem,auto]   items-start  products">
      <div class="row-span-2 min-h-60rem" ref="bott">
        <List pagerBar sortBar layout :span="spanNum" :data="data" v-slot="{ item }" @sorts="sorts"
          @synsorts="getProductList" @changeSpan="changeSpan" v-if="spanNum == 5">
          <Item :item="item" :flight="flight"></Item>
        </List>

        <List pagerBar sortBar layout :span="spanNum" :data="data" v-slot="{ item }" @sorts="sorts"
          @synsorts="getProductList" @changeSpan="changeSpan" v-else>
          <ItemThree :item="item" :flight="flight"></ItemThree>
        </List>
      </div>

      <div class="mt-12 relative" ref="orderBlank">
        <div class="space-y-3 bg-white px-4 absolute" ref="tab"
          :class="{ is_fixed_top: isFixedTop, is_fixed_bottom: isFixedBottom }">
          <div>
            <Goods @goods-list="ch"></Goods>
          </div>
          <div class="pp">
            <p class="flex items-center">
              <span>{{ $t("收货信息") }}</span>
            </p>
          </div>
          <div>
            <Address :item="addr"></Address>
          </div>
          <div class="pp">
            <p>
              <span>{{ $t("总额") }}</span>
            </p>
          </div>
          <div>
            <Money class="text-left" :values="money_info"></Money>
          </div>

          <div class="text-left pb-2">
            <el-button type="danger" @click="submitForm">
              {{
                $t("提交订单")
              }}
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Address from "@/components/flight/address.vue";
import Goods from "@/components/flight/goods.vue";
import Money from "/src/components/base/money.vue";
import {
  computed,
  reactive,
  ref,
  watchEffect,
  onMounted,
  onBeforeUnmount
} from "@vue/composition-api";
import Classify from "@/components/product/classify.vue";
import List from "@/components/base/list.vue";
import Item from "@/components/base/item2.vue";
import ItemThree from "@/components/base/item3.vue";


export default {
  components: {
    Goods,
    Money,
    Address,

    Classify,
    List,
    Item,
    ItemThree,

  },
  setup(props, ctx) {
    const changeSpan = (val) => {
      spanNum.value = val;
    };
    const flight = ref(Number(ctx.root.$route.params.id));
    const items = ref();
    const dialogTableVisible = ref(false);
    const spanNum = ref(Number(5));
    const sorts = (value) => {
      getProductList(value);
    };
    const money_info = reactive({
      total: null,
    });
    const addr = ref();


    const getLockAddress = async () => {
      let res = await ctx.root.$callapi('user/getAddress', {
        aid: user.value?.user_lock_address
      })
      if (res.code == 0 && res.data) {
        addr.value = res.data
      }
    }
    onMounted(() => {
      getLockAddress()
    });
    const goods_info = ref();
    const ch = async (val) => {
      goods_info.value = val;
      money_info.total = computed(() => {
        return val.map(item => item._num.value * item.price).reduce((a,b)=>a+b,0)
      });
    };



    const data = ref();
    const getProductList = async (value) => {
      const query = {
        size: 25,
        orderby: value || ctx.root.$route.query.orderby || "-updated",
        q__pproduct__classify_id: ctx.root.$route.query.classify_id,
        q__name__icontains: ctx.root.$route.query.keyword,
        page: ctx.root.$route.query.page,
        color: ctx.root.$route.query.color,
        wh:ctx.root.$route.query.wh || 'origin'
      };
      if (Number(query.q__pproduct__classify_id) === 0) {
        Reflect.deleteProperty(query, "q__pproduct__classify_id");
      }

      await ctx.root.$callapi("getProductList", query).then((d) => {
        data.value = reactive(d.data);
      });
    };
    watchEffect(() => {
      getProductList();
    });
    const user = computed(() => ctx.root.$store.getters.user);

    const submitForm = async () => {
      if (!user.value.user_lock_address) {
        return ctx.root.$toast('您还未选择地址', 'warning')
      }
      console.log(goods_info.value);
      if (goods_info.value.length) {
        let cids = goods_info.value.map(i => i.cid)
        let sids = [...new Set(goods_info.value.map(i => i.supplier_info.sid))]
        ctx.root.$router.push({
          path: "/product/dealOrder",
          query: {
            cids: cids.join(','),
            sids: sids.join(',')
          }
        })
      } else {
        ctx.root.$toast(ctx.root.$t("你还没有选择结算的商品"), "warning");
      }
    };

    // 获取 要活动的 div
    const tab = ref();
    const bott = ref();
    const isRemove = ref(false);


    const isFixedTop = ref(false);
    const isFixedBottom = ref(false);

    const initHeight = () => {
      const offsetTop =
        ctx.refs.orderBlank.offsetTop

      const offsetHeight = ctx.refs.tab.offsetHeight;
      const scrollHeight = document.body.scrollHeight;
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      isFixedTop.value =
        scrollTop > offsetTop &&
          scrollTop < scrollHeight - offsetHeight - 450
          ? true
          : false;
      isFixedBottom.value =
        scrollTop > scrollHeight - offsetHeight - 450 ? true : false;

    };
    onMounted(() => {
      window.addEventListener("scroll", initHeight);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("scroll", initHeight);
    });
    const modifyAddr = (e) => {
      addr.value = e;
      dialogTableVisible.value = false;
    };
    return {
      addr,
      items,
      data,
      ch,
      money_info,
      submitForm,
      sorts,
      getProductList,
      flight,
      tab,
      isRemove,
      bott,
      spanNum,
      dialogTableVisible,
      modifyAddr,
      changeSpan,
      isFixedTop,
      isFixedBottom,
    };
  },
};
</script>

<style scoped lang="scss">
.pp {
  &>p {
    @apply text-left bg-gray-200 text-lg font-bold pl-3 flex;

    &>span+span {
      @apply ml-auto pr-3;
    }
  }
}

.remove {
  @apply relative;
}

.pointer {
  div {
    @apply cursor-pointer;
  }
}
.products{
  grid-column-gap: 0.5rem;
  grid-template-columns:calc(100% - 34.5rem) 34rem;
}
.is_fixed_top {
  @apply fixed top-0 w-34rem z-99;
}

.is_fixed_bottom {
  @apply fixed bottom-38rem w-34rem z-99;
}
</style>
